export default __webpack_public_path__ + "locales/si/JavascriptSdk.json?hash=617ea66a0a0f44e624681491ec021b80";